import Media from '@model/content/Media'

class MediaImage extends Media {
    constructor(object) {
        super(object)
    }
}

export default MediaImage
